import { AnyStore } from 'src/stores';

import { SidebarSettingsType } from '../types';

export const sidebarStore = new AnyStore(false);
export const sidebarSettingsStore = new AnyStore<SidebarSettingsType>({});
